import each from 'lodash/each';
import curry from 'lodash/curry';
import debounce from 'lodash/debounce';

const _recursiveCurried = curry(_recursive);

const TIMEOUT_PERIOD = 17;

/* eslint no-invalid-this: 0 */
export default {
   methods: {
      _deepListener: debounce(function _deepListenerDebounced() {

         _recursive('$off', this._deepListener, this);
         _recursive('$on', this._deepListener, this);

         this.$emit('deep:updated');
      }, TIMEOUT_PERIOD)
   },
   mounted() {
      _recursive('$on', this._deepListener, this);
   },
   beforeDestroy() {
      _recursive('$off', this._deepListener, this);
   }
};

function _recursive(method, listener, vm) {
   vm.$on('hook:updated', listener);
   each(vm.$children, _recursiveCurried(method, listener));
}
